import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import StationDetailsForm from "../../../components/forms/setup/stations/StationDetailsForm";
import { createSnackbarHelpers } from "../../../shared/snackbar";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function StationsViewModel(logout, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [stations, setStations] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [formInProgress, setFormInProgress] = useState(false);

  const { showSuccess } = createSnackbarHelpers(addSnackbar);

  const getStations = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `stations?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setStations(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createStation = async function (values) {
    setFormInProgress(true);
    const payload = { ...values };
    let callResult = await makePostApiCall("stations/create", payload);

    if (callResult.success) {
      showSuccess("Station added");
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getStations("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
    setFormInProgress(false);
  };

  const updateStation = async function (values, index) {
    setFormInProgress(true);
    let callResult = await makePutApiCall(`stations/${values.id}`, values);

    if (callResult.success) {
      showSuccess("Station updated");
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...stations.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setStations({ ...stations, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
    setFormInProgress(false);
  };

  const openAddStationSlideOver = (isEdit, station, index) => {
    setSlideOver({
      childComponent: (
        <StationDetailsForm
          station={station}
          isEdit={isEdit}
          inProgress={formInProgress}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateStation(payload, index) : createStation(payload)
          }
          title={isEdit ? `Update ${station.name}` : "Add new station"}
        />
      ),
      open: true,
    });
  };

  const deleteStation = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteStation/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = stations.data.filter((item) => item.id !== id);
      setStations({ ...stations, data: newItems });

      showSuccess(callResult.data.message);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteStation = function (station, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteStation(station.id, index)}
          message={`Are you sure you want to delete  ${station.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddStationSlideOver,
    getStations,
    loading,
    stations,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDeleteStation,
  };
}
